import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PortalPreviewData } from './portal-preview.model';

interface ItemPedidoExemplo {
  nome: string;
  sku: string;
  quantidade: string;
  unidade: string;
  precoUnitario: string;
  tributos: string;
  subtotal: string;
}

interface ParcelaExemplo {
  sequencia: string;
  vencimento: string;
  valor: string;
}

// Preview do documento de pedido enviado ao fornecedor (portal/PDF/e-mail).
// Renderiza com o branding e as seções habilitadas na configuração atual;
// itens e valores são dados de exemplo.
@Component({
  selector: 'app-portal-pedido-preview',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './portal-pedido-preview.component.html',
  styleUrls: ['../../../../shared/styles/portal-preview-shared.css', './portal-pedido-preview.component.css'],
})
export class PortalPedidoPreviewComponent {
  public readonly itens: ItemPedidoExemplo[] = [
    { nome: 'Papel sulfite A4 75g', sku: 'PAP-A4-75', quantidade: '50', unidade: 'cx', precoUnitario: 'R$ 189,90', tributos: 'R$ 474,75', subtotal: 'R$ 9.969,75' },
    { nome: 'Toner HP 414A preto', sku: 'TON-414A-PT', quantidade: '8', unidade: 'un', precoUnitario: 'R$ 412,00', tributos: 'R$ 164,80', subtotal: 'R$ 3.460,80' },
    { nome: 'Cadeira de escritório ergonômica', sku: 'MOB-CAD-ERG', quantidade: '12', unidade: 'un', precoUnitario: 'R$ 780,00', tributos: 'R$ 468,00', subtotal: 'R$ 9.828,00' },
  ];

  public readonly parcelas: ParcelaExemplo[] = [
    { sequencia: '1/3', vencimento: '01/08/2026', valor: 'R$ 7.936,18' },
    { sequencia: '2/3', vencimento: '31/08/2026', valor: 'R$ 7.936,18' },
    { sequencia: '3/3', vencimento: '30/09/2026', valor: 'R$ 7.936,19' },
  ];

  constructor(
    public dialogRef: MatDialogRef<PortalPedidoPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PortalPreviewData
  ) {}

  public isAtivo(chave: string): boolean {
    return this.data.camposAtivos.includes(chave);
  }

  public get heroGradient(): string {
    return `linear-gradient(135deg, ${this.data.corHeroInicio}, ${this.data.corHeroFim})`;
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
